import { IUserStatistics } from '@interfaces/user';
import { getAndFormatUserStatistics } from '@services/users/users.services';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import useIsLoggedIn from 'src/apis/queries/useIsLoggedIn';
import { userKeys } from '../queriesKeys';
import { TUserStatisticsReturnType } from './userUserStatistics.type';

const useUserStatistics = <TReturnType = IUserStatistics>(
	select?: (data: IUserStatistics) => TReturnType
): TUserStatisticsReturnType<TReturnType> => {
	const queryClient = useQueryClient();
	const { isLoggedIn } = useIsLoggedIn();

	const queryResult = useQuery({
		queryKey: userKeys.statistics(),
		queryFn: getAndFormatUserStatistics,
		enabled: isLoggedIn,
		select
	});

	const updateUserStatistics = useCallback(async () => {
		await queryClient.invalidateQueries({ queryKey: userKeys.statistics(), refetchType: 'all' });
	}, [queryClient]);

	return { userStatistics: queryResult.data as TReturnType, updateUserStatistics, ...queryResult };
};

export { useUserStatistics };
